import { useEffect, useRef, useState } from "react";
import { animate, useInView } from "framer-motion";
import { FadeUp } from "@/components/Reveal";
import { STATS } from "@/data/site";

const CountUp = ({ value }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });
  const num = parseInt(value, 10);
  const suffix = value.replace(/[0-9]/g, "");
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, num, {
      duration: 1.7,
      ease: [0.22, 1, 0.36, 1],
      onUpdate: (v) => setDisplay(Math.round(v)),
    });
    return () => controls.stop();
  }, [inView, num]);

  return (
    <span ref={ref}>
      {display}
      {suffix}
    </span>
  );
};

export default function StatsBand({ testId = "stats-band" }) {
  return (
    <section data-testid={testId} className="border-y border-white/10 bg-coal">
      <div className="max-w-7xl mx-auto grid grid-cols-2 lg:grid-cols-4">
        {STATS.map((s, i) => (
          <FadeUp
            key={s.label}
            delay={i * 0.1}
            className={`px-6 sm:px-10 py-10 sm:py-14 ${
              i !== 0 ? "border-l border-white/10" : ""
            } ${i >= 2 ? "border-t lg:border-t-0 border-white/10" : ""}`}
          >
            <p data-testid={s.testId} className="font-display text-5xl sm:text-6xl text-gold tracking-tight">
              <CountUp value={s.value} />
            </p>
            <p className="mt-3 text-[11px] sm:text-xs uppercase tracking-[0.22em] text-zinc-400">{s.label}</p>
          </FadeUp>
        ))}
      </div>
    </section>
  );
}
